import React from 'react'
import Form from 'components/form/Form'
import { Field } from 'redux-form'
import InputField from 'components/form/InputField'
import TextareaField from 'components/form/TextareaField'

export const ContactForm = props => {
	const { message } = props
	return <Form {...props}>
		<Field
			name='name'
			type='text'
			label='Име'
			labelClassName='u-margin-right-small'
			component={InputField}
			className='c-input--text-normal'
			formGroupClassName='c-form-field-panel u-margin-bottom u-padding-vertical-small'
		/>
		<Field
			name='phone'
			type='text'
			label='Телефон'
			labelClassName='u-margin-right-small'
			component={InputField}
			className='c-input--text-normal'
			formGroupClassName='c-form-field-panel u-margin-bottom u-padding-vertical-small'
		/>
		<Field
			name='email'
			type='email'
			label='Email'
			labelClassName='u-margin-right-small'
			component={InputField}
			className='c-input--text-normal'
			formGroupClassName='c-form-field-panel u-margin-bottom u-padding-vertical-small'
		/>
		<Field
			name='message'
			label='Съобщение'
			labelClassName='o-block o-block--left u-margin-bottom-small'
			component={TextareaField}
			className='u-padding-small'
			formGroupClassName='u-padding-vertical-small'
		/>
		{ message && <div className='u-margin-bottom u-text--apple u-text--center'>{message}</div>}
		<div className='o-block'>
			<button className='c-btn u-bg--cornflower u-padding-horizontal u-padding-vertical-small u-text--white' type='submit'>Изпрати</button>
		</div>
	</Form>
}